import LocalesEnum from '../enums/LocalesEnum'

const LocalesMacher = {
  Czech: LocalesEnum.cs,
  French: LocalesEnum.fr,
  German: LocalesEnum.de,
  Slovak: LocalesEnum.sk,
  Spanish: LocalesEnum.es,
}

export default LocalesMacher
